export var WS_CLIENT_KEEP_ALIVE = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
export var WS_CLIENT_RETRIES = 100;
export var WS_CLOSE_ON_IDLE = 300000; // 5m